import React, { lazy, Suspense, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './i18n/index.js';
import './App.css';
import AgeGate from './components/AgeGate/AgeGate';
import AnnouncementBar from './components/AnnouncementBar/AnnouncementBar';
import HomePage from './views/HomePage';

const Chatbot = lazy(() => import('./components/Chatbot/Chatbot'));
const JoinUs = lazy(() => import('./views/JoinUs'));
const ServicesPage = lazy(() => import('./views/ServicesPage'));
const RatesPage = lazy(() => import('./views/RatesPage'));
const RoomsPage = lazy(() => import('./views/RoomsPage'));
const LadiesPage = lazy(() => import('./views/LadiesPage'));
const LadyProfilePage = lazy(() => import('./views/LadyProfilePage'));
const RosterPage = lazy(() => import('./views/RosterPage'));

function safeSession(key) {
  try { return sessionStorage.getItem(key); } catch { return null; }
}

function App() {
  const verified = safeSession('on_age_verified') === 'true';
  const [ageOk, setAgeOk] = useState(verified);

  return (
    <HelmetProvider>
      {!ageOk && <AgeGate onEnter={() => setAgeOk(true)} />}
      {ageOk && (
        <div className="App">
          <AnnouncementBar />
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/en" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/en/services" element={<ServicesPage />} />
              <Route path="/rates" element={<RatesPage />} />
              <Route path="/en/rates" element={<RatesPage />} />
              <Route path="/rooms" element={<RoomsPage />} />
              <Route path="/en/rooms" element={<RoomsPage />} />
              <Route path="/join-us" element={<JoinUs />} />
              <Route path="/en/join-us" element={<JoinUs />} />
              <Route path="/ladies" element={<LadiesPage />} />
              <Route path="/en/ladies" element={<LadiesPage />} />
              <Route path="/ladies/:slug" element={<LadyProfilePage />} />
              <Route path="/en/ladies/:slug" element={<LadyProfilePage />} />
              <Route path="/roster" element={<RosterPage />} />
              <Route path="/en/roster" element={<RosterPage />} />
            </Routes>
          </Suspense>
          <Suspense fallback={null}>
            <Chatbot />
          </Suspense>
        </div>
      )}
    </HelmetProvider>
  );
}

export default App;
